import $api from "@/api/index";
import { UserI } from "@/types/base";

export async function getPaymentLink(): Promise<string> {
  const response = await $api.get<{ data: { confirmation_url: string } }>(
    "/v2/subscriptions/payments/payment-create"
  );

  return response.data.data.confirmation_url;
}

export async function getConfirmPaymentLink(): Promise<string> {
  const response = await $api.get<{ data: { confirmation_url: string } }>(
    "/v2/subscriptions/payments/card-change"
  );

  return response.data.data.confirmation_url;
}

export async function cancelSubscription(telegramId: number): Promise<UserI> {
  const response = await $api.post(
    "/v2/subscriptions/payments/create-subscription-event",
    {
      telegram_id: telegramId,
      event: "cancelled_subscription",
    }
  );

  return response.data;
}
